import axios from '@axios'

export default {
  getOpApis(page, field) {
    return axios.post(`platform/opapis/list?page=${page}`, field)
  },
}
